import { SowRetainedTeamStats } from '../model/sow-retained-team-stats.model'

export const resolveShowUseRetainedTeamToggle = (retainedTeamStats: SowRetainedTeamStats[], rateCardId: number) =>
  retainedTeamStats?.some((teamStats) => teamStats.rateCardId === rateCardId)
